<template>
    <div class="module">
        <header class="module__header--with-disclaimer">
            <h1>Developers</h1>
        </header>

        <section class="module__body">
            <Tabs value="0">
                <TabList>
                    <Tab value="0">Docs</Tab>
                    <Tab value="1">Route Table</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel value="0">
                        <ApiDocuments></ApiDocuments>
                    </TabPanel>
                    <TabPanel value="1">
                        <ApiRouteTable></ApiRouteTable>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </section>
    </div>
</template>

<script>
import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'
import ApiDocuments from '@/components/Developers/ApiDocuments.vue'
import ApiRouteTable from '@/components/Developers/ApiRouteTable.vue'

export default {
    components: {
        ApiDocuments,
        ApiRouteTable,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
    },

    data() {
        return {}
    },
}
</script>
